<template>
  <div>
    <SidebarVue ref="sidebar" />
    <Navgator
      ref="navgator"
      :barraTitulo="' Atendimento'"
      :titulo="'novo atendimento'"
    />

    <div class="card-container">
      <div class="card card-table-txt">
        <nav class="navbar navbar-atend">
          <div class="container-fluid">
            <div class="row g-2">
              <div class="card-title gy-4">
                <i class="bi bi-list-ul fs-5 icon-text-form"></i>
                <span class="txt-title-form">Fila de Atendimento</span>
              </div>
            </div>
            <div class="d-flex gap-2">
              <a
                href="/atendimento/agendar_proposta"
                ref="tooltipTrigger"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                :title="tooltipText2"
              >
                <i class="bi bi-calendar-event"></i>
              </a>
              <a
                href="/atendimento/proposta"
                ref="tooltipTrigger"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                :title="tooltipText"
              >
                <i class="bi bi-plus-circle"></i>
              </a>
            </div>
          </div>
        </nav>

        <div class="card card-table-txt">
          <div class="d-md-none">
            <div
              v-for="item in usuarios_dispo"
              :key="item.id"
              class="accordion mb-2"
            >
              <div class="accordion-item">
                <button
                  class="accordion-button collapsed card-table-txt"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#row-' + item.id"
                >
                  {{ item.vendedor.username }}
                </button>
                <div :id="'row-' + item.id" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <p>
                      <strong>Nº Atendimento:</strong>
                      {{ item.id }}
                    </p>
                    <p>
                      <strong>Tipo Vendedor:</strong>
                      {{
                        item.vendedor.tipo_vend[0]?.tipo_vendedor === 1
                          ? "Novo"
                          : item.vendedor.tipo_vend[0]?.tipo_vendedor === 2
                          ? "Usado"
                          : item.vendedor.tipo_vend[0]?.tipo_vendedor === 3
                          ? "Ambos"
                          : "Não definido"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-none d-md-block">
            <table class="table rf_texto">
              <thead>
                <tr>
                  <th scope="col">Vendedor</th>
                  <th scope="col">Tipo Vendedor</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in usuarios_dispo"
                  :key="item.id"
                  :class="['table-linha', getStatusClass(item)]"
                >
                  <td>{{ item.vendedor.username }}</td>
                  <td>
                    {{
                      item.vendedor.tipo_vend[0]?.tipo_vendedor === 1
                        ? "Novo"
                        : item.vendedor.tipo_vend[0]?.tipo_vendedor === 2
                        ? "Usado"
                        : item.vendedor.tipo_vend[0]?.tipo_vendedor === 3
                        ? "Ambos"
                        : "Não definido"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="card-container">
      <div class="card card-table-txt">
        <nav class="navbar navbar-atend">
          <div class="container-fluid">
            <div class="row g-2">
              <div class="card-title gy-4">
                <i class="bi bi-hourglass-split fs-5 icon-text-form"></i>
                <span class="txt-title-form">Indisponível</span>
              </div>
            </div>
          </div>
        </nav>

        <div class="card card-table-txt">
          <div class="d-md-none">
            <div
              v-for="item in usuarios_ind"
              :key="item.id"
              class="accordion mb-2"
            >
              <div class="accordion-item">
                <button
                  class="accordion-button collapsed card-table-txt"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#row-' + item.id"
                  :class="{
                    cor_venda_finalizada_mob:
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta === 'Venda Finalizada',
                    cor_venda_perdida_mob:
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta === 'Venda Perdida',
                    cor_aguardando_aprovacao_mob:
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta === 'Aguardando Aprovação',
                    cor_em_atendimento_mob:
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta === 'Atendimento',
                    cor_atendimento_apos_45_mob:
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta === 'Atendimento Excedido',
                    cor_aguardando_atendimento_mob:
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta === 'Aguardando Atendimento',
                    cor_atendimento_agendado_mob:
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta === 'Atendimento Agendado',
                    cor_fila_mob:
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta === 'Fila de Espera'
                  }"
                >
                  <td>{{ item.vendedor.username }}</td>
                </button>
                <div :id="'row-' + item.id" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <p>
                      <strong>Nº Atendimento:</strong>
                      {{ item.vendedor?.proposta_vendedores?.[0]?.id || "N/A" }}
                    </p>
                    <p>
                      <strong>Cliente:</strong>
                      {{
                        item.vendedor?.proposta_vendedores?.[0]?.clientes
                          ?.nome || "N/A"
                      }}
                    </p>

                    <p>
                      <strong>Status Atendimento:</strong>
                      {{
                        item.vendedor?.proposta_vendedores?.[0]
                          ?.status_proposta || "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-none d-md-block d-lg-none">
            <div class="table-responsive">
              <table class="table table-sm card-table-txt">
                <thead class="table-light">
                  <tr>
                    <th scope="col">Nº Atendimento</th>
                    <th scope="col">Cliente</th>
                    <th scope="col">Vendedor</th>
                    <th scope="col">Status Proposta</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in usuarios_ind"
                    :key="item.id"
                    :class="{
                      cor_venda_finalizada_mob:
                        item.vendedor?.proposta_vendedores?.[0]
                          ?.status_proposta === 'Venda Finalizada',
                      cor_venda_perdida_mob:
                        item.vendedor?.proposta_vendedores?.[0]
                          ?.status_proposta === 'Venda Perdida',
                      cor_aguardando_aprovacao_mob:
                        item.vendedor?.proposta_vendedores?.[0]
                          ?.status_proposta === 'Aguardando Aprovação',
                      cor_em_atendimento_mob:
                        item.vendedor?.proposta_vendedores?.[0]
                          ?.status_proposta === 'Atendimento',
                      cor_atendimento_apos_45_mob:
                        item.vendedor?.proposta_vendedores?.[0]
                          ?.status_proposta === 'Atendimento Excedido',
                      cor_aguardando_atendimento_mob:
                        item.vendedor?.proposta_vendedores?.[0]
                          ?.status_proposta === 'Aguardando Atendimento',
                      cor_atendimento_agendado_mob:
                        item.vendedor?.proposta_vendedores?.[0]
                          ?.status_proposta === 'Atendimento Agendado',
                      cor_fila_mob:
                        item.vendedor?.proposta_vendedores?.[0]
                          ?.status_proposta === 'Fila de Espera'
                    }"
                  >
                    <td class="fw-bold">
                      {{ item.vendedor?.proposta_vendedores?.[0]?.id || "N/A" }}
                    </td>
                    <td>
                      {{
                        item.vendedor?.proposta_vendedores?.[0]?.clientes
                          ?.nome || "N/A"
                      }}
                    </td>
                    <td>{{ item.vendedor.username }}</td>
                    <td>
                      <span
                        class="badge"
                        :class="{
                          cor_venda_finalizada_mob:
                            item.vendedor?.proposta_vendedores?.[0]
                              ?.status_proposta === 'Venda Finalizada',
                          cor_venda_perdida_mob:
                            item.vendedor?.proposta_vendedores?.[0]
                              ?.status_proposta === 'Venda Perdida',
                          cor_aguardando_aprovacao_mob:
                            item.vendedor?.proposta_vendedores?.[0]
                              ?.status_proposta === 'Aguardando Aprovação',
                          cor_em_atendimento_mob:
                            item.vendedor?.proposta_vendedores?.[0]
                              ?.status_proposta === 'Atendimento',
                          cor_atendimento_apos_45_mob:
                            item.vendedor?.proposta_vendedores?.[0]
                              ?.status_proposta === 'Atendimento Excedido',
                          cor_aguardando_atendimento_mob:
                            item.vendedor?.proposta_vendedores?.[0]
                              ?.status_proposta === 'Aguardando Atendimento',
                          cor_atendimento_agendado_mob:
                            item.vendedor?.proposta_vendedores?.[0]
                              ?.status_proposta === 'Atendimento Agendado',
                          cor_fila_mob:
                            item.vendedor?.proposta_vendedores?.[0]
                              ?.status_proposta === 'Fila de Espera'
                        }"
                      >
                        {{
                          item.vendedor?.proposta_vendedores?.[0]
                            ?.status_proposta || "N/A"
                        }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="d-none d-lg-block">
            <table class="table rf_texto">
              <thead>
                <tr>
                  <th scope="col">Nº Atendimento</th>
                  <th scope="col">Cliente</th>
                  <th scope="col">Vendedor</th>
                  <th scope="col">Status Vendedor</th>
                  <th scope="col">Status Proposta</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in usuarios_ind"
                  :key="item.id"
                  :class="{
                    cor_venda_finalizada_mob:
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta === 'Venda Finalizada',
                    cor_venda_perdida_mob:
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta === 'Venda Perdida',
                    cor_aguardando_aprovacao_mob:
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta === 'Aguardando Aprovação',
                    cor_em_atendimento_mob:
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta === 'Atendimento',
                    cor_atendimento_apos_45_mob:
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta === 'Atendimento Excedido',
                    cor_aguardando_atendimento_mob:
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta === 'Aguardando Atendimento',
                    cor_atendimento_agendado_mob:
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta === 'Atendimento Agendado',
                    cor_fila_mob:
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta === 'Fila de Espera'
                  }"
                >
                  <td>
                    {{ item.vendedor?.proposta_vendedores?.[0]?.id || "N/A" }}
                  </td>
                  <td>
                    {{
                      item.vendedor?.proposta_vendedores?.[0]?.clientes?.nome ||
                      "N/A"
                    }}
                  </td>
                  <td>{{ item.vendedor.username }}</td>
                  <td>{{ item.status }}</td>
                  <td>
                    {{
                      item.vendedor?.proposta_vendedores?.[0]
                        ?.status_proposta || "N/A"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="abrir_modal">
      <Message :msg="msg" v-show="msg" />
    </div>

    <!--Modal Veiculo Avaliação-->
    <div
      class="modal fade"
      id="ModalEditarPlaca"
      aria-hidden="true"
      aria-labelledby="exampleModalToggleLabel2"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
            <span class="txt-title-modal">Editar Placa</span>

            <button
              class="btn-close"
              type="button"
              data-bs-toggle="modal"
              aria-label="Close"
            ></button>
          </div>

          <div class="modal-body txt-body-modal">
            <form @submit.prevent="editar_placa">
              <!--Item-->
              <div class="row g-2 p-2">
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      type="text"
                      class="form-control txt-form-input"
                      v-model="edit_id"
                      disabled
                    />
                    <label>Atendimento</label>
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <input
                      type="text"
                      class="form-control txt-form-input"
                      v-model="placa_av"
                    />
                    <label>Placa *</label>
                  </div>
                </div>
              </div>
              <div class="row g-2 p-2">
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-floating txt-form-label">
                    <button class="btn btn-modal btn-lg p-1 mt-1" type="submit">
                      <span>Atualizar</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <RodapeVue />
  </div>
</template>
<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import userService from "../../services/user.service";
//import Pagination from "../../components/Pagination.vue";
import Message from "../../components/modal/Message.vue";
import RodapeVue from "../../components/menu/Rodape.vue";
import Navgator from "../../components/menu/Navgator.vue";
//import DraggableTableVue from "../../components/DraggableTable.vue"
//import DraggableTableVueMob from "../../components/DraggableTableMob.vue";

import TokenService from "../../services/token.service";
import jwt_decode from "jwt-decode";

import { Tooltip } from "bootstrap"; // Importe o Tooltip do Bootstrap

export default {
  name: "Atendimento",
  components: {
    SidebarVue,
    Navgator,
    //Pagination,
    Message,
    RodapeVue
    //DraggableTableVueMob,
    //DraggableTableVue
  },
  data() {
    return {
      abrir_modal: false,
      msg: "",
      valid: false,
      usuarios_dispo: [],
      usuarios_ind: [],
      funcoes: [],
      atendimento: [],
      proposta: [],
      searchTitle: "",

      //Paginação vendedores indisponiveis
      page_ind: 1,
      totalPages_ind: 0,
      totalItems_ind: 0,
      pageSizes_ind: [100],
      pageSize_ind: 100,

      //Paginação vendedores disponiveis
      page_disp: 1,
      totalPages_disp: 0,
      totalItems_disp: 0,
      pageSizes_disp: [100],
      pageSize_disp: 100,

      //Paginação
      page: 1,
      totalPages: 0,
      totalItems: 0,
      pageSizes: [100],
      pageSize: 100,

      //Campos Formulário
      username: "",
      email: "",
      password: "",
      funcao: "",
      message: "",
      dialog: "",
      placa_av: "",
      edit_id: "",
      modal: false,
      modal_msg: false,

      status_proposta: "",
      tooltipText: "Criar novo atendimento",
      tooltipText2: "Criar novo atendimento agendado",
      tooltipInstance: null
    };
  },

  mounted() {
    this.getToken();
    this.retrieveVendedorInd();
    this.retrieveVendedorDispo();
    //this.retrievePropostas();
    this.initTooltip();
  },

  methods: {
    initTooltip() {
      if (this.$refs.tooltipTrigger) {
        // Destrói instância anterior se existir
        if (this.tooltipInstance) {
          this.tooltipInstance.dispose();
        }

        // Cria nova instância com trigger hover
        this.tooltipInstance = new Tooltip(this.$refs.tooltipTrigger, {
          trigger: "hover" // Só hover, sem focus
        });
      }
    },

    beforeUnmount() {
      // Limpeza ao desmontar
      if (this.tooltipInstance) {
        this.tooltipInstance.dispose();
      }
    },
    atualizarLista(novaLista) {
      // Atualiza a lista local sem precisar recarregar do servidor
      this.usuarios_dispo = novaLista;

      // Se você quiser manter a paginação, pode precisar ajustar:
      if (novaLista.length < this.pageSize_disp && this.page_disp > 1) {
        this.page_disp -= 1;
        this.retrieveVendedorDispo(); // Recarrega a página anterior se necessário
      }
    },

    async salvarOrdenacao(novaOrdem) {
      try {
        // Prepara os dados para enviar ao backend
        const payload = novaOrdem.map((vendedor, index) => ({
          id: vendedor.id,
          nome: vendedor.username,
          prioridade_vendedor: index + 1 // Ou outro campo que determine a ordem
        }));
        console.log("Dados da reordenação", payload);
        // Envia para a API
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}reordenar_vendedores`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
          }
        );

        if (response.ok) {
          this.message = "Ordenação salva com sucesso!";
          this.dialog = true;

          // Atualiza localmente sem recarregar a página
          this.usuarios_dispo = novaOrdem;
        } else {
          throw new Error("Falha ao salvar ordenação");
        }
      } catch (error) {
        console.error("Erro ao salvar ordenação:", error);
        this.message = "Erro ao salvar ordenação. Recarregando dados...";
        this.dialog = true;

        // Reverte para os dados do servidor em caso de erro
        //this.retrieveVendedorDispo();
      }
    },

    getStatusClass(item) {
      console.log(item);
      return {
        "table-success":
          item.vendedor?.proposta_vendedores?.[0]?.status_proposta ===
          "Atendimento",
        vendedor_offline: item.vendedor?.proposta_vendedores?.length === 0
      };
    },
    getToken() {
      const accessToken = TokenService.getLocalAccessToken();

      // Obter o token de atualização (refresh token)
      TokenService.getLocalRefreshToken();

      // Obter o usuário completo (incluindo os tokens) se necessário
      TokenService.getUser();

      const decodedToken = jwt_decode(accessToken);

      this.empresa_id = decodedToken.company;
    },

    getTipoVend(tipo_vendedor) {
      return tipo_vendedor == 0 ? "Novo" : "Usado";
    },

    //Tornar vendedores disponiveis e indisponiveis
    async desabilitar_vend(item) {
      console.log(item);
      const id = item.id;
      const response = await fetch(
        `${process.env.VUE_APP_API_URL}status_vendedor/${id}`,
        {
          method: "PUT",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            status_vendedor: 3
          })
        }
      );
      const resp = JSON.stringify(response.status);
      console.log(resp);
      if (resp == 200) {
        this.dialog = true;
        this.message = "Vendedor está desabilitado para atendimento!";
        this.retrieveVendedorDispo();
        this.retrieveVendedorInd();
        document.location.reload(true);
      }
    },
    async update_dispo(item) {
      console.log(item);
      const id = item.id;
      const response = await fetch(
        `${process.env.VUE_APP_API_URL}status_vendedor/${id}`,
        {
          method: "PUT",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            status_vendedor: 1
          })
        }
      );
      const resp = JSON.stringify(response.status);
      console.log(resp);
      if (resp == 200) {
        this.dialog = true;
        this.message = "Vendedor se tornou Indisponível!";
        this.retrieveVendedorDispo();
        this.retrieveVendedorInd();
        document.location.reload(true);
      }
    },
    async editar_proposta(item) {
      console.log(item);
      this.edit_id = item.id;
      this.placa_av = item.placa_avaliacao;
      //const id = item.id;
      // const response = await fetch(
      //   `${process.env.VUE_APP_API_URL}status_vendedor/${id}`,
      //   {
      //     method: "PUT",

      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //     body: JSON.stringify({
      //       status_vendedor: 1,
      //     }),
      //   }
      // );
      // const resp = JSON.stringify(response.status);
      // console.log(resp);
      // if (resp == 200) {
      //   this.dialog = true;
      //   this.message = "Vendedor se tornou Indisponível!";
      //   this.retrieveVendedorDispo();
      //   this.retrieveVendedorInd();
      //   document.location.reload(true);
      // }
    },
    async editar_placa() {
      const id = this.edit_id;
      const placa_avaliacao = this.placa_av;
      const response = await fetch(
        `${process.env.VUE_APP_API_URL}editar_placa/${id}`,
        {
          method: "PUT",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: id,
            placa_avaliacao: placa_avaliacao
          })
        }
      );
      const resp = JSON.stringify(response.status);
      console.log(resp);
      if (resp == 200) {
        this.dialog = true;
        this.message = "Placa atualizada com sucesso!";
        this.retrieveVendedorDispo();
        this.retrieveVendedorInd();
        document.location.reload(true);
      }
    },

    //Buscar dados no banco de dados vendedores indisponiveis
    getRequestParams_ind(searchTitle, page_ind, pageSize_ind, empresa_id) {
      let params = {};
      if (searchTitle) {
        params["nome"] = searchTitle;
      }
      if (page_ind) {
        params["page"] = page_ind - 1;
      }
      if (pageSize_ind) {
        params["size"] = pageSize_ind;
      }
      if (empresa_id) {
        params["empresa_id"] = empresa_id;
      }
      return params;
    },
    handlePageChange_ind(value) {
      this.page_ind = value;
      this.retrieveVendedorInd();
    },
    handlePageSizeChange_ind(size) {
      this.pageSize_ind = size;
      this.page_ind = 1;
      this.retrieveVendedorInd();
    },
    async retrieveVendedorInd() {
      try {
        const params = this.getRequestParams_ind(
          this.searchTitle,
          this.page_ind,
          this.pageSize_ind,
          this.empresa_id
        );
        const response = await userService.getVendedorInd(params);
        const user_ind = response.data.rows;
        this.usuarios_ind = user_ind;
        console.log("Usuarios indisponíveis", user_ind);
      } catch (error) {
        console.log(error);
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },

    //Buscar dados no banco de dados vendedores disponiveis
    getRequestParams_disp(searchTitle, page_disp, pageSize_disp, empresa_id) {
      let params = {};
      if (searchTitle) {
        params["nome"] = searchTitle;
      }
      if (page_disp) {
        params["page"] = page_disp - 1;
      }
      if (pageSize_disp) {
        params["size"] = pageSize_disp;
      }
      if (empresa_id) {
        params["empresa_id"] = empresa_id;
      }
      return params;
    },
    handlePageChange_disp(value) {
      this.page_disp = value;
      this.retrieveVendedorDispo();
    },
    handlePageSizeChange_disp(size) {
      this.pageSize_disp = size;
      this.page_disp = 1;
      this.retrieveVendedorDispo();
    },
    async retrieveVendedorDispo() {
      try {
        const params = this.getRequestParams_disp(
          this.searchTitle,
          this.page_disp,
          this.pageSize_disp,
          this.empresa_id
        );
        const response = await userService.getVendedorOrdenado(params);
        const users = response.data.rows;
        console.log("Vendedores disponiveis", users);

        this.usuarios_dispo = users;
      } catch (error) {
        console.log(error);
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },

    //Buscar dados no banco de dados Proposta
    getRequestParams(searchTitle, page, pageSize, empresa_id, status_proposta) {
      let params = {};
      if (searchTitle) {
        params["nome"] = searchTitle;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (empresa_id) {
        params["empresa_id"] = empresa_id;
      }
      if (status_proposta) {
        params["status_proposta"] = status_proposta;
      }
      return params;
    },
    handlePageChangeProposta(value) {
      this.page = value;
      this.retrievePropostas();
    },
    handlePageSizeChangeProposta(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrievePropostas();
    },

    async retrievePropostas() {
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          this.page,
          this.pageSize,
          this.empresa_id,
          this.status_proposta
        );

        userService
          .getPropostaMenu(params)
          .then((response) => {
            this.status_proposta = "";
            const { propostas, totalPages } = response.data;
            this.proposta = propostas;
            this.totalPages = totalPages;
            console.log("Dados da Proposta");
            console.log(this.proposta);
            console.log(response.data);
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.abrir_modal = true;
              this.msg = error.response.data.message;
            }
          });
      } catch (error) {
        console.log(error);
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    }
  }
};
</script>
